import styled from "styled-components"

const StyledOrderCourierForm = styled.section`
  padding: 100px 0 150px 0;
  .order-courier-form {
    &__header {
      text-align: center;
      margin: 0 0 85px 0;
    }
    &__subheader {
      text-align: center;
      max-width: 860px;
      margin: 0 auto 50px;
    }
    &__info {
      background-color: #f5f3f3;
      padding: 30px 30px 30px 80px;
      position: relative;
      &:before {
        content: "";
        width: 20px;
        height: 20px;
        position: absolute;
        top: 30px;
        left: 30px;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZyBpZD0iSWNvbl9mZWF0aGVyLWluZm8iIGRhdGEtbmFtZT0iSWNvbiBmZWF0aGVyLWluZm8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPgogICAgPHBhdGggaWQ9IlBhdGhfNDk5IiBkYXRhLW5hbWU9IlBhdGggNDk5IiBkPSJNMjMsMTNBMTAsMTAsMCwxLDEsMTMsMywxMCwxMCwwLDAsMSwyMywxM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zIC0zKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfNTAwIiBkYXRhLW5hbWU9IlBhdGggNTAwIiBkPSJNMTgsMjRWMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC05LjI1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfNTAxIiBkYXRhLW5hbWU9IlBhdGggNTAxIiBkPSJNMTgsMTJoMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTYpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      &-row {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -10px;
      }
      &-col {
        margin: 0 10px;

        &.col-6 {
          flex-basis: calc(50% - 20px);
          max-width: calc(50% - 20px);
        }
      }
      a {
        text-decoration: underline;
        font-weight: 500;
        transition: 0.2s;
        &:hover {
          color: #00fb6e;
        }
      }
      p:not(:last-child) {
        margin-bottom: 20px;
      }
    }
    &__cta {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 65px 0 0 0;
    }
  }
  .form-error {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 0;
    right: 0;
    font-size: 12px;
    line-height: 24px;
    letter-spacing: 1.4px;
    font-weight: 500;
    text-transform: uppercase;
    color: #fc0303;
  }
  .form-step {
    animation-name: fade;
    animation-duration: 0.3s;
  }
  @media screen and (max-width: 900px) {
    padding: 150px 0 75px;
    margin-top: -150px;
    display: ${({ show_form }) => (show_form ? "block" : "none")};
    .order-courier-form {
      &__header {
        display: none;
      }
      &__subheader {
        margin: 0 auto 30px;
        font-size: 18px;
        line-height: 28px;
      }
      &__cta {
        margin: 30px 0 0 0;
      }
      &__info {
        padding: 60px 20px 20px;
        &:before {
          top: 23px;
          left: 20px;
        }
        &-row {
          margin: 0;
        }
        &-col {
          margin: 0;
          &.col-6 {
            flex-basis: 100%;
            max-width: 100%;
            &:first-child {
              margin-bottom: 15px;
            }
          }
        }
        p:not(:last-child) {
          margin-bottom: 15px;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .order-courier-form {
      &__cta {
        flex-direction: column-reverse;
        button {
          min-width: 100%;
          svg {
            display: none;
          }
          &:last-child {
            margin-bottom: 15px;
            background-color: #000;
            span {
              color: #fff;
            }
          }
        }
      }
    }
  }
  @keyframes fade {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export default StyledOrderCourierForm
